import React from 'react';
import { useTranslation } from 'react-i18next';
import { General } from 'icons/untitledui';
import FilledDocumentIcon from 'form/assets/filledForm.svg?react';
import UnfilledDocumentIcon from 'form/assets/unfilledForm.svg?react';
import { usePosthogCapture } from 'form/posthogCapture/_index';
import * as Styled from 'form/styles/SmartActionFormButton.style';

interface SmartActionFormButtonProps {
  templateName: string;
  isFilled: boolean;
  summary?: string;
  fileUrl?: string;
  onClick: () => void;
}

export default function SmartActionFormButton({
  templateName,
  isFilled,
  summary,
  fileUrl,
  onClick,
}: SmartActionFormButtonProps): JSX.Element {
  const { t } = useTranslation('pageForm');
  const posthogCapture = usePosthogCapture();

  const handleDownloadClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    posthogCapture.smartActionDownloadSelected({ templateName, isFilled });
  };

  return (
    <Styled.Container onClick={onClick} type="button" $isFilled={isFilled}>
      <Styled.IconWrapper>
        {isFilled ? <FilledDocumentIcon /> : <UnfilledDocumentIcon />}
      </Styled.IconWrapper>

      <Styled.TextContent>
        <Styled.Title>
          {isFilled ? templateName : t('smartAction.fillThisForm')}
        </Styled.Title>
        <Styled.Subtitle>{isFilled ? summary : templateName}</Styled.Subtitle>
      </Styled.TextContent>

      {isFilled && fileUrl && (
        <Styled.DownloadButton
          as="a"
          $size="small"
          href={fileUrl}
          onClick={handleDownloadClick}
          aria-label={t('form.download')}
        >
          <General.Download01 />
        </Styled.DownloadButton>
      )}
    </Styled.Container>
  );
}
